import MinedUpgradeAutomation from "../../../model/automation/MinedUpgradeAutomation";
import AutomationView from "../../common/AutomationView";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import { PageIds } from "../../PageIds";
import MinedUpgradeCollectionView from "./MinedUpgradeCollectionView";

export default class FreeUpgradePanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {MinedUpgradeCollectionView} minedUpgradeCollection
     * @param {MinedUpgradeAutomation} minedUpgradeAutomation
     */
    constructor(parentId, minedUpgradeCollection, minedUpgradeAutomation) {
        super(parentId, PageIds.FREE_UPGRADES_PANEL);

        this.addView(new MinedUpgradeCollectionView(this.elementId, PageIds.MINED_UPGRADES_PANEL, minedUpgradeCollection));

        this.addView(new AutomationView(this.elementId, this.elementId + '_auto', 'Auto Claim', minedUpgradeAutomation));

    }

    /**
     * @override
     */
    initializeView() {

        // <div id="freeUpgradesPanel" class="primary-upgrade-panel-body">
        //   <div id="unlockLayerPanel"></div>
        //   <div id="minedUpgradesPanel"></div>
        // </div>

        const parent = Page.getElement(this.parentId);
        Page.createElement('div', parent, this.elementId, 'primary-upgrade-panel-body');

        super.initializeView();
    }
}